const ar = {
  // Layout
  "admin.siteName": "السياحية",
  "admin.role.admin": "مدير",
  "admin.role.writer": "كاتب",
  "admin.nav.dashboard": "لوحة الإحصائيات",
  "admin.nav.articles": "إدارة المقالات",
  "admin.nav.newArticle": "إضافة مقال",
  "admin.nav.videos": "إدارة الفيديوهات",
  "admin.nav.adPackages": "باقات الإعلانات",
  "admin.nav.adPlacements": "مواضع الإعلانات",
  "admin.nav.adRequests": "طلبات الإعلانات",
  "admin.nav.aboutPage": "صفحة عن الصحيفة",
  "admin.nav.gccGuide": "دليل الخليج",
  "admin.nav.users": "إدارة المستخدمين",
  "admin.nav.categories": "إدارة التصنيفات",
  "admin.nav.settings": "الإعدادات",
  "admin.nav.newspaperPdf": "العدد اليومي PDF",
  "admin.nav.infographics": "إدارة الإنفوغرافيك",
  "admin.nav.opinion": "مقالات الرأي",
  "admin.nav.analytics": "إحصائيات مفصلة",
  "admin.nav.socialLinks": "حسابات التواصل الاجتماعي",
  "admin.nav.contactMessages": "رسائل القراء",
  "admin.nav.ogPreview": "اختبار المشاركة",
  "admin.nav.mainSite": "الموقع الرئيسي",
  "admin.nav.logout": "تسجيل الخروج",
  "admin.logout.title": "تسجيل الخروج",
  "admin.logout.confirm": "هل أنت متأكد من تسجيل الخروج؟",
  "admin.logout.confirmBtn": "تأكيد الخروج",
  "admin.logout.cancel": "إلغاء",

  // Article Form
  "article.form.newTitle": "إضافة مقال جديد",
  "article.form.editTitle": "تعديل المقال",
  "article.form.cancel": "إلغاء",
  "article.form.saving": "جارٍ الحفظ...",
  "article.form.saved": "تم الحفظ!",

  // Settings — Article Display Flags
  "settings.articleFlags.title": "عناصر عرض المقالات",
  "settings.articleFlags.subtitle": "تحكم في إظهار أو إخفاء عناصر المقالات في الموقع",
  "settings.articleFlags.showPublishDate": "تاريخ النشر",
  "settings.articleFlags.showAuthor": "اسم الكاتب",
  "settings.articleFlags.showViews": "عدد المشاهدات",
  "settings.articleFlags.showReadTime": "زمن القراءة",
  "settings.articleFlags.showCategory": "التصنيف",
  "settings.articleFlags.showShareCount": "عدد المشاركات",
  "settings.articleFlags.save": "حفظ إعدادات عرض المقالات",
  "article.form.publish": "نشر المقال",
  "article.form.saveChanges": "حفظ التعديلات",
  "article.form.langLabel": "لغة المقال",
  "article.form.langAr": "عربي",
  "article.form.langEn": "English",

  // Article fields — Arabic
  "article.field.titleAr": "عنوان المقال (عربي)",
  "article.field.titleEn": "Article Title (English)",
  "article.field.titlePlaceholderAr": "أدخل العنوان الرئيسي للمقال...",
  "article.field.titlePlaceholderEn": "Enter the main article title...",
  "article.field.excerptAr": "مقدمة المقال (عربي)",
  "article.field.excerptEn": "Article Excerpt (English)",
  "article.field.excerptPlaceholderAr": "مقدمة قصيرة تظهر في بطاقة الخبر...",
  "article.field.excerptPlaceholderEn": "Short intro shown in the news card...",
  "article.field.contentLabel": "نص المقال الكامل",
  "article.field.contentPlaceholderAr": "اكتب نص المقال الكامل هنا...",
  "article.field.contentPlaceholderEn": "Write the full article content here...",
  "article.field.chars": "حرف",

  // Image
  "article.image.label": "الصورة الرئيسية",
  "article.image.change": "تغيير الصورة",
  "article.image.delete": "حذف الصورة",
  "article.image.dropTitle": "اضغط لرفع صورة أو اسحب وأفلت",
  "article.image.dropSub": "PNG, JPG, WEBP — بحد أقصى 5 ميغابايت",
  "article.image.choose": "اختر صورة",

  // Sidebar
  "article.sidebar.publishSettings": "إعدادات النشر",
  "article.sidebar.category": "التصنيف",
  "article.sidebar.author": "الكاتب",
  "article.sidebar.authorPlaceholder": "اسم الكاتب",
  "article.sidebar.tags": "الوسوم (مفصولة بفاصلة)",
  "article.sidebar.tagsPlaceholder": "مثال: دبي، سياحة، 2026",
  "article.sidebar.source": "مصدر الخبر",
  "article.sidebar.sourceName": "اسم المصدر",
  "article.sidebar.sourceNamePlaceholder": "مثال: رويترز، CNN عربية...",
  "article.sidebar.sourceUrl": "رابط المصدر",
  "article.sidebar.featured": "الواجهة الرئيسية",
  "article.sidebar.featuredToggle": "ترفيع للواجهة",
  "article.sidebar.featuredDesc": "يظهر في قسم الأخبار المميزة",
  "article.sidebar.preview": "معاينة البطاقة",
  "article.sidebar.previewTitle": "عنوان المقال",
  "article.sidebar.previewExcerpt": "مقدمة المقال...",
  "article.sidebar.previewAuthor": "الكاتب",
  "article.sidebar.featured.badge": "مرفّع",
};

export default ar;
